import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'outgoing-fee-invoice-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class OutgoingFeeInvoiceActionComponent extends BaseReportActionsDialog implements OnInit {
  constructor(
    private formlyService: GaFormlyService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      withChecks: true
    };

    // create fields
    this.fields = this.createFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTemplate('<p>This action will create proforma invoices for all selected rows.</p>')
        .build(),
      this.formlyService.aCheckbox('withChecks', 'With optional checks')
        .withoutWrapper()
        .build(),
      this.formlyService.aTemplate(
        `
          <br/>
          <p>
            Optional checks: The action will check that 
            <ul>
              <li>order has shipped</li>
              <li>acsl received the fees from BP (local billing) or Customer (central billing)</li>
              <li>invoice total is more than minimum specified in the template</li>
            </ul>
          </p>
          <br/>
          <p>You can choose to run the action without these optional checks.</p>
          <br/>
          <p>
            Mandatory checks: The action will also check that 
            <ul>
              <li>fee has not yet been invoiced</li>
              <li>invoice template for outgoing fees exists</li>
              <li>invoice contact and location are available</li>
              <li>invoice currency is USD or EUR</li>
            </ul>
          </p>
          <br/>
          <p>You cannot run the action without these mandatory checks.</p>
        `
      )
        .build()
    ];
  }
}